export default {
  banners: (state) => state.banners,
  privateOffersBanners: (state) => state.privateOffersBanners,
  bannersInfo: (state) => state.bannersInfo,
  privateBannersInfo: (state) => state.privateBannersInfo,
  sortedBanners: (state) => state.sortedBanners,
  status: (state) => state.status,
  activeBannerId: (state) => state.activeBannerId,
  activePlace: (state) => state.activePlace,
  activeBanner: (state) => state.activeBanner,
  loading: (state) => state.loading,
  copiedBannerInformation: (state) => state.copiedBannerInformation,
};
